VLW.controllers.LesHommes = class extends VLW.controllers.Home {
	constructor(a, b) {
		super(a, b);
		this.constructor.setStyleMenuHover("color_gris");
		this.pixi.align                                                  = "cc";
		this.pixi.displacementType                                       = VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HOMMES;
		this.isSubMenuOpen                                               = false;
		this.liSubContent                                                = [...this.subMenu.querySelectorAll("._contentLi")];
		this.pixiEnfant                                                  = new VLW.LesHommesEnfantPIXI({stage: this.pixi});
		this.aMainElements                                               = {};
		this.aMainElements[this.mainElementJS.getAttribute("data-code")] = this.mainElementJS;
		!VERSION_SMARTP && document.body.appendChild(this.subMenu);
		this.initSubMenuEvent();
	}
	
	onClickMenu(e) {
		if (this.isSubMenuOpen === true) {
			return;
		}
		this.showSubMenu();
		this.pixiEnfant.onMouseEnter();
	}
	
	reload(elt) {
		this.hideSubMenu(1,false);
		let _code = elt.getAttribute("data-code");
		if (!this.aMainElements[_code]) {
			this.aMainElements[_code] = elt;
			TweenMax.set(elt.querySelectorAll("._filet"), {opacity: .7, className: "+=__transitionable"});
			this.mainElementJS.parentNode.appendChild(elt);
		}
		TweenMax.killTweensOf(this.mainElementJS);
		TweenMax.to(this.mainElementJS, .5, {opacity: 0, pointerEvents: "none", ease: Power1.easeOut});
		this.mainElementJS = this.aMainElements[_code];
		this.init_vlwScroll();
		if (_code !== "1300-LesHommes") {
			this.pixiEnfant.eltSelected = _code;
			!VERSION_SMARTP && TweenMax.to("._voileNoir", .75, {opacity: .8, ease: Sine.easeIn, display: "block"});
			TweenMax.fromTo(this.mainElementJS, .5, {opacity: 0, pointerEvents: "auto"}, {opacity: 1, ease: Power1.easeIn});
		} else {
			TweenMax.to("._voileNoir", .75, {opacity: 0, ease: Sine.easeOut, display: "none"});
			!VERSION_SMARTP && this.onClickMenu();
			 VERSION_SMARTP && (this.pixiEnfant.eltSelected = "");
			 VERSION_SMARTP && (TweenMax.to(this.mainElementJS, .5, {opacity: 1, pointerEvents: "auto",}));
		}
	}
	
	onMouseSubMenuContentMove(e) {
		let rect = e.currentTarget.getBoundingClientRect();
		let x    = e.clientX - rect.left;
		let y    = e.clientY - rect.top;
		this.pixiEnfant.onMouseMoveElt(x / e.currentTarget.clientWidth, y / e.currentTarget.clientHeight);
	}
	
	onMouseSubMenuContentEnter(e) {
		this.pixiEnfant.onMouseEnterElt(e.currentTarget.getAttribute("data-code"));
	}
	
	initSubMenuEvent() {
		BUREAU_ONLY && this.subMenu.addEventListener("mouseleave", this.onMouseSubMenuLeave);
		BUREAU_ONLY && window.addEventListener("mousemove", this.onMouseMove, supportsPassive);
		BUREAU_ONLY && this.liSubContent.forEach((elt) => {
				elt.vlwIndex = getIndex(elt.parentNode) + 1;
				elt.addEventListener("mouseenter", this.onMouseSubMenuContentEnter);
				elt.addEventListener("mousemove", this.onMouseSubMenuContentMove);
			}
		);
		//BUREAU_ONLY && [...this.subMenu.querySelectorAll("a[data-code]")].forEach((elt) => elt.addEventListener("click", this.onClickSubMenu));
	}
	
	onMenuHover() {
		super.onMenuHover();
		this.hideSubMenu();
	}
	
	onMouseMove(e) {
		let _x = (e.clientX - getDocSize().width * .5);
		let _y = (e.clientY - getDocSize().height * .5);
		this.liSubContent.forEach((elt) => {
			let _oTween = {
				rotationY: 0.01 * _x,
				rotationX: 0.01 * _y,
				x        : 0.005 * _x * elt.vlwIndex * 2,
				y        : 0.01 * _y * (elt.vlwIndex - 1)
			};
			if (this.isSubMenuOpen === true) {
				const _bound    = elt.getBoundingClientRect();
				const _x2       = (e.clientX - (_bound.left + (_bound.width * .5)));
				const _y2       = (e.clientY - (_bound.top + (_bound.height * .5)));
				const _inX      = e.clientX.between(_bound.left, _bound.right);
				const _inY      = e.clientY.between(_bound.top, _bound.bottom);
				const _rationIn = (_inX === true && _inY === true) ? 1 : 0;
				_oTween         = {
					rotationY: 0.1 * _x2 * _rationIn,
					rotationX: 0.2 * -_y2 * _rationIn,
					x        : 0.025 * _x,
					force3D  : false,
				}
			}
			TweenMax.to(elt.querySelector("._image"), .5, _oTween);
		});
	}
	
	introContent() {
		super.introContent();
		return true;
	}
	
	loadPIXIResources() {
		let _loader = new PIXI.loaders.Loader();
		_loader.add("image", this.getPIXIResourcesBackground());
		_loader.add("displacement", "/images/displacement/leshommes.jpg");
		_loader.load((loader, resources) => {
			this.pixi.resources = resources;
			this.loadPIXIResources_enfant();
			loader.destroy();
		});
	}
	
	outro() {
		super.outro();
		TweenMax.killTweensOf("._voileNoir");
		TweenMax.to("._voileNoir", .75, {opacity: 0, ease: Sine.easeOut, display: "none"});
		//this.tlIntro.pause();
		this.pixiEnfant.onCtrlOutro();
		this.subMenu.removeEventListener("mouseenter", this.onMouseSubMenuEnter);
		window.removeEventListener("mousemove", this.onMouseMove, supportsPassive);
		this.liSubContent.forEach((elt) => {
				elt.vlwIndex = getIndex(elt.parentNode) + 1;
				elt.removeEventListener("mouseenter", this.onMouseSubMenuContentEnter);
				elt.removeEventListener("mousemove", this.onMouseSubMenuContentMove);
			}
		);
		this.subMenu.removeEventListener("mouseleave", this.onMouseSubMenuLeave);
		window.removeEventListener("mousemove", this.onMouseMove);
		TweenMax.killTweensOf(this.subMenu);
		TweenMax.to(this.subMenu, .5, {
			opacity         : 0,
			onComplete      : (elt) => {removeNode(elt)},
			onCompleteParams: [this.subMenu]
		});
	}
	
	showSubMenu() {
		broadCaster.BACKGROUND_HIDE.dispatch();
		TweenMax.to(this.mainElementJS, .5, {opacity: 0, pointerEvents: "none",});
		TweenMax.to(this.subMenu, 0.75, {opacity: 1, ease: Power2.easeIn});
		TweenMax.set(this.subMenu, {pointerEvents: "auto", delay: .75});
		TweenMax.staggerFromTo(this.subMenu.querySelectorAll("li"), 0.75, {y: -50, opacity: 0}, {y: 0, opacity: 1, ease: Sine.easeInOut}, .1);
		this.isSubMenuOpen = true;
	}
	
	hideSubMenu(backgroundDispatchDelay=0,hidePixiEnfant) {
		if (this.isSubMenuOpen === false) {
			return;
		}
		TweenMax.delayedCall(backgroundDispatchDelay,broadCaster.BACKGROUND_SHOW.dispatch);
		this.isSubMenuOpen               = false;
		this.subMenu.style.pointerEvents = "none";
		TweenMax.to(this.subMenu, 0.5, {opacity: 0});
		TweenMax.to(this.mainElementJS, .5, {opacity: 1, pointerEvents: "auto",});
		hidePixiEnfant && this.pixiEnfant.onMouseLeave()
	}
	
	onMouseSubMenuLeave(e) {
		this.hideSubMenu(0,true);
	}
	
	loadPIXIResources_enfant() {
		let jsonData = JSON.parse(this.mainElementJS.getAttribute("data-background-enfant"));
		let _loader  = new PIXI.loaders.Loader();
		_loader.add("mask", "/images/mask/hommes-enfant.png");
		for (let prop in jsonData) _loader.add(prop, jsonData[prop].image);
		_loader.load((loader, resources) => {
			this.pixiEnfant.resources = resources;
			loader.destroy();
		});
		return;
	}
};